
import "/Users/profmea/admin/src/components/RightContent/ChangePasswordModal.less?modules";
export default {"form-actions": `form-actions-zuBZlCW6`,"change-password-modal": `change-password-modal-AeSHk6d9`}
